import { render, staticRenderFns } from "./ClientAuditsTab.vue?vue&type=template&id=8a906774&scoped=true&"
import script from "./ClientAuditsTab.vue?vue&type=script&lang=js&"
export * from "./ClientAuditsTab.vue?vue&type=script&lang=js&"
import style0 from "./ClientAuditsTab.vue?vue&type=style&index=0&id=8a906774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a906774",
  null
  
)

export default component.exports